export const scoreTone = (n) => {
  if (n == null) return { chip: "bg-zinc-100 text-zinc-500", text: "text-zinc-500", bar: "bg-zinc-300" };
  if (n >= 85) return { chip: "bg-emerald-100 text-emerald-800", text: "text-emerald-700", bar: "bg-emerald-500" };
  if (n >= 65) return { chip: "bg-amber-100 text-amber-800", text: "text-amber-700", bar: "bg-amber-500" };
  return { chip: "bg-red-100 text-red-700", text: "text-red-600", bar: "bg-red-500" };
};

export const CAT_LABELS = {
  speed: "Speed", mobile: "Mobile", looks: "Design", words: "Words",
  conversion: "Conversion", findability: "Findability", trust: "Trust & security",
};
